import { render, staticRenderFns } from "./ChangePrimaryDomainView.vue?vue&type=template&id=d71f3966&"
import script from "./ChangePrimaryDomainView.vue?vue&type=script&lang=js&"
export * from "./ChangePrimaryDomainView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d71f3966')) {
      api.createRecord('d71f3966', component.options)
    } else {
      api.reload('d71f3966', component.options)
    }
    module.hot.accept("./ChangePrimaryDomainView.vue?vue&type=template&id=d71f3966&", function () {
      api.rerender('d71f3966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/domains/ChangePrimaryDomainView.vue"
export default component.exports